<template>
  <div
    class="notfound absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
  >
    <div class="notfound-404">
      <h3>Oops! Page not found</h3>
      <h1>
        <span>4</span>
        <span>0</span>
        <span>4</span>
      </h1>
    </div>
    <h2>we are sorry, but the page you requested was not found</h2>
  </div>
</template>

<style scoped>
.notfound {
  max-width: 520px;
  width: 100%;
  line-height: 1.4;
  text-align: center;
}

.notfound .notfound-404 {
  position: relative;
  height: 240px;
}

.notfound .notfound-404 h1 {
  position: absolute;
  left: 50%;
  top: calc(50% + 15px);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);

  margin: 0px;
  color: var(--text-color-1);
  text-transform: uppercase;
  letter-spacing: -10px;
  margin-left: -10px;
  transform: translate(-50%, -50%);
  margin-bottom: 0;
}

.notfound .notfound-404 h3 {
  position: relative;
  font-size: 1.5rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 3px;
  padding-left: 6px;
  margin-bottom: 0;
  color: var(--text-color-1);
}

.notfound .notfound-404 h1 > span {
  font-size: 252px;
  font-weight: 900;
  text-shadow: -6px 0 0 var(--body-bg-color);
}

.notfound h2 {
  font-size: 20px;
  font-weight: 400;
  text-transform: uppercase;
  margin-bottom: 25px;
  color: var(--text-color-1);
}

@media only screen and (max-width: 767px) {
  .notfound .notfound-404 {
    height: 200px;
  }
  .notfound .notfound-404 h1 > span {
    font-size: 200px;
  }
}

@media only screen and (max-width: 480px) {
  .notfound .notfound-404 {
    height: 162px;
  }
  .notfound .notfound-404 h1 {
    font-size: 162px;
    height: 150px;
    line-height: 162px;
    top: calc(50% + 10px);
  }
  .notfound h2 {
    font-size: 16px;
  }
}
</style>
